export default __webpack_public_path__ + "static/media/logo-white.843c93af.png";